<!-- tel-input.vue -->
<template>
  <vue-tel-input
    v-model='value'
    :disabled='disabled'
    :defaultCountry='schema.defaultCountry'
    :onlyCountries='schema.onlyCountries'
    :preferredCountries='schema.preferredCountries'
    :placeholder='schema.placeholder'
    :required='schema.required'
    :hint='schema.hint'
    @input='schema.input'
    @validate='schema.validate'
  ></vue-tel-input>
</template>

<script>
import { abstractField } from "vue-form-generator";

export default {
  name: "TelephoneInput",
  mixins: [abstractField],
};
</script>
